/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ---------------------------------------------------------------------------------------------
 */

import { style } from 'typestyle';

export function bannerStyles(themedColors: any) {
  return {
    common: {
      topBanner: style({
        overflow: 'hidden',
        fontFamily: "Segoe UI",
        backgroundColor: themedColors.bannerBackground,
        position: 'fixed', /* Set the navbar to fixed position */
        top: '0', /* Position the navbar at the top of the page */
        width: '100%', /* Full width */
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        zIndex: 100,
        $nest: {
          'div': {
            color: themedColors.bannerTextColor,
            fontSize: '14px',
            fontWeight: 600,
            letterSpacing: '0px',
            lineHeight: '20px',
            paddingTop: '9px',
            paddingLeft: '16px',
          },
          'span': {
            alignSelf: 'center',
          },
          'a': {
            color: themedColors.bannerTextColor,
            fontSize: '14px',
            fontWeight: 600,
            height: '20px',
            letterSpacing: '0px',
            lineHeight: '20px',
          },
          'i': {
            color: themedColors.bannerCloseColor,
          },
        },
      }),
    }
  }
}